import React from 'react';
import PropTypes from 'prop-types';
import { UUModal, Button } from '@unite-us/ui';

const ConfirmationModal = ({ modalRef, submitMergeForm }) => {
  const handleClose = () => {
    modalRef.current.closeModal();
  };

  return (
    <UUModal
      ref={modalRef} title="Confirm Merge" size="normal"
      onRequestClose={handleClose}
      modal
      actions={(
        <div className="flex justify-end gap-6">
          <Button
            label="Close"
            secondary
            onClick={handleClose}
          />
          <Button
            label="Merge Records"
            primary
            data-testid="merge-records-button"
            onClick={submitMergeForm}
          />
        </div>
      )}
    >
      <div className="flex flex-col space-y-4 pb-6">
        <div className="text-sm">
          You are about to merge these records.
        </div>
        <div className="text-sm text-red">
          This action can&apos;t be undone.
        </div>
      </div>
    </UUModal>
  );
};

ConfirmationModal.propTypes = {
  modalRef: PropTypes.object.isRequired,
  submitMergeForm: PropTypes.func,
};

ConfirmationModal.defaultProps = {
  submitMergeForm: null,
};

export default ConfirmationModal;
